export const lightTheme = {
    body: "#FFFFFF",
    text: "#000000",
    heading: "#333333",
    cardBg: "#F9F9F9",
    skeletonCard: "linear-gradient(to right, #eaeaea, #d4d4d4, #f0f0f0)",
  };
  
  export const darkTheme = {
    body: "#121212",
    text: "#FFFFFF",
    heading: "#CCCCCC",
    cardBg: "#1E1E1E",
    skeletonCard: "linear-gradient(to right, #3a3a3a, #2e2e2e, #4a4a4a)",
  };
  